module.exports = __webpack_public_path__ + "static/justinFace-a73bd7fe498eed26bd85c29b85e9269f.jpg";